var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bread" }, [
    _vm._v("\n  位置：\n  "),
    _c("span", { class: { "bread-active": _vm.cur_bread.length == 1 } }, [
      _vm._v("\n          " + _vm._s(_vm.cur_bread[0]) + "\n      "),
    ]),
    _vm._v(" "),
    _vm.cur_bread.length > 1
      ? _c("span", { class: { "bread-active": _vm.cur_bread.length == 2 } }, [
          _vm._v("\n          >" + _vm._s(_vm.cur_bread[1]) + "\n      "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }